<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { SectionCardData } from '$lib/api/types';

  export let data: SectionCardData;
  export let editable = false;

  const dispatch = createEventDispatcher<{
    change: SectionCardData;
  }>();

  let editing = false;
  let editLabel = data.label;

  function startEditing() {
    if (!editable) return;
    editLabel = data.label;
    editing = true;
  }

  function handleSave() {
    if (editLabel !== data.label) {
      dispatch('change', { ...data, label: editLabel });
    }
    editing = false;
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      handleSave();
    }
    if (event.key === 'Escape') {
      editing = false;
    }
  }

  // Size classes
  $: sizeClasses = {
    S: 'text-sm',
    M: 'text-base',
    L: 'text-lg',
  }[data.fontSize || 'M'];
</script>

<div
  class="h-full flex items-center px-4 py-2"
  style:color={data.textColor || undefined}
>
  {#if editing}
    <input
      type="text"
      bind:value={editLabel}
      placeholder="セクション名"
      class="flex-1 px-2 py-1 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 outline-none bg-white text-gray-900 relative z-30"
      on:blur={handleSave}
      on:keydown={handleKeydown}
    />
  {:else}
    <div
      class="flex items-center gap-2 cursor-text {sizeClasses} relative z-30"
      on:click={startEditing}
      role={editable ? 'button' : undefined}
      tabindex={editable ? 0 : undefined}
    >
      {#if data.icon}
        <span>{data.icon}</span>
      {/if}
      <span class="font-semibold text-gray-600">{data.label}</span>
    </div>
  {/if}
</div>
